import Image from 'next/image';

import exampleImg1 from './images/recommend/1.jpg';
import exampleImg2 from './images/recommend/2.jpg';
import exampleImg3 from './images/recommend/3.jpg';
import exampleImg4 from './images/recommend/4.jpg';
import exampleImg5 from './images/recommend/5.jpg';

type ExamplePersona = {
  image: StaticImageData;
  description: string;
};

const Component: React.FC = () => {
  const personas: ExamplePersona[] = [
    {
      image: exampleImg1,
      description: '卓球をやっている子どもに実践的なテクニックを伝えたい！',
    },
    {
      image: exampleImg2,
      description: '試合中のミスを少なくして、安定したプレイをしたい',
    },
    {
      image: exampleImg3,
      description: 'サーブとレシーブを強化して、試合運びを上達したい',
    },
    {
      image: exampleImg4,
      description: '個人レッスンに行きたいが、予算的に難しい...',
    },
    {
      image: exampleImg5,
      description: '球出しのコツや、練習メニューのつくり方がわからない',
    },
  ];

  const mainTextClass =
    'flex items-center text-lg text-[#202956] md:text-gray-600 text-center font-bold mb-5';

  return (
    <div className="mb-3 mt-2 flex flex-col items-center">
      <div className={mainTextClass}>
        Shakehandsは
        <br />
        初心者から上級者、指導者まで
        <br className="md:hidden" />
        すべてのお悩みを解決します。
      </div>
      <div className="mb-3 flex w-[calc(100%+20px)] flex-col items-start gap-y-4 bg-[#F5F6FF] px-5 py-4 md:w-full md:flex-row md:gap-x-4 md:gap-y-0 md:bg-transparent md:p-0">
        {personas.map(persona => (
          <div
            key={persona.description}
            className="flex flex-row-reverse rounded border-[#202956] text-sm md:flex-col md:items-center md:border-4 md:bg-transparent md:p-4 md:font-bold"
          >
            <div>{persona.description}</div>
            <Image
              alt=""
              src={persona.image}
              className="mr-2 w-10 rounded-full border-[3px] border-solid border-[#202956] md:mr-0 md:mt-4 md:w-[66px]"
            />
          </div>
        ))}
      </div>
      <div className={mainTextClass}>
        指導経験豊富なコーチ陣とつくる
        <br />
        コンテンツ・動画だからこそ
        <br className="md:hidden" />
        全ての卓球ユーザーにおすすめできる
      </div>
    </div>
  );
};

export default Component;
